/* Todaysunny 3.8. Deterministic selected-item checkout; does not mutate the Ajax cart. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.TSCheckout = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  function positiveInteger(value) {
    const raw = String(value ?? '').trim();
    if (!/^\d+$/.test(raw)) return null;
    const number = Number(raw);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  }
  function validQuantity(value, rules = {}) {
    const quantity = positiveInteger(value);
    const min = positiveInteger(rules.min) || 1;
    const max = positiveInteger(rules.max);
    const step = positiveInteger(rules.step) || 1;
    return quantity !== null && quantity >= min && (!max || quantity <= max) && (quantity - min) % step === 0;
  }
  function encodeProperties(properties) {
    const entries = Object.entries(properties || {}).filter(([, value]) => value !== '' && value !== null && value !== undefined);
    if (entries.length > 25) throw new Error('This configuration needs the shopping bag. Please use Add to cart.');
    if (entries.some(([, value]) => typeof value !== 'string')) throw new Error('Please use Add to cart for this product configuration.');
    if (!entries.length) return '';
    const json = JSON.stringify(Object.fromEntries(entries));
    // The URL cannot safely transport file properties or unbounded custom text.
    if (json.length > 6000) throw new Error('Please use Add to cart for this product configuration.');
    const bytes = new TextEncoder().encode(json);
    let binary = '';
    for (const byte of bytes) binary += String.fromCharCode(byte);
    const base64 = typeof btoa === 'function' ? btoa(binary) : Buffer.from(bytes).toString('base64');
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }
  function buildCheckoutURL({ origin, cartPath = '/cart', variantId, quantity = 1, locale = '', properties = {}, sellingPlan = '' }) {
    if (sellingPlan) throw new Error('Please use Add to cart for subscription purchases.');
    const id = String(variantId ?? '').trim();
    if (!/^\d+$/.test(id) || !positiveInteger(id)) throw new Error('Choose an available product option before buying.');
    if (!validQuantity(quantity)) throw new Error('Choose a valid whole-number quantity.');
    if (!/^\/(?:[A-Za-z0-9-]+\/)?cart\/?$/.test(cartPath)) throw new Error('The checkout address is not available. Please use Add to cart.');
    const base = new URL(origin);
    if (base.protocol !== 'https:' || base.username || base.password) throw new Error('A secure checkout address is required.');
    const url = new URL(`${cartPath.replace(/\/$/, '')}/${id}:${positiveInteger(quantity)}`, base.origin);
    if (locale && /^[A-Za-z]{2,3}(?:-[A-Za-z0-9]{2,8})*$/.test(locale)) url.searchParams.set('locale', locale);
    const encoded = encodeProperties(properties);
    if (encoded) url.searchParams.set('properties', encoded);
    // Without storefront=true, Shopify resolves a permalink directly to checkout.
    return url.href;
  }
  return Object.freeze({ validQuantity, buildCheckoutURL });
});
